import React, { useState } from "react";
import Button from "@material-ui/core/Button";
// import { Link } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

// import { firestore } from '../../../components/firebase/FirebaseProvider';
import ImageGelombang from "../../../assets/images/login-gelombang.svg";
import Navbar from "../../../components/molecules/navbarLogReg";
import ImageFamily from "../../../assets/images/family.svg";
import ImageKonfirmasi from "../../../assets/images/image-form.svg";
import ImageOrderBuy from "../../../assets/icon/imageOderBuy.svg";
import { useData } from "../../../components/firebase/DataProvider";
import useStyles from "./style";
import { useDocumentData } from "react-firebase-hooks/firestore";
import {
  auth,
  firefunctions,
  firestore,
} from "../../../components/firebase/FirebaseProvider";
import { useSnackbar } from "notistack";
import { arrayToCurrencyString } from "../../../utils/currency";
import Typography from "@material-ui/core/Typography";

export default function Form() {
  const classes = useStyles();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const matches = useMediaQuery(theme.breakpoints.up("951"));
  const matches1 = useMediaQuery(theme.breakpoints.up("1156"));
  const [year] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { profil, global_settings, profilRef, configuration } = useData();

  const [free_deposit_mentorbisnis, loadingDepositMentorbisnis] =
    useDocumentData(
      firestore.doc(
        `/settings/free_deposit/uids/${profil?.ref_mentorbisnis?.user_id}`
      )
    );

  const [free_deposit_distributor, loadingDepositDistributor] = useDocumentData(
    firestore.doc(
      `/settings/free_deposit/uids/${profil?.ref_distributor?.user_id}`
    )
  );

  const [free_deposit_agen, loadingDepositAgen] = useDocumentData(
    firestore.doc(`/settings/free_deposit/uids/${profil?.ref_agen?.user_id}`)
  );

  const [free_deposit_all, loadingDepositAll] = useDocumentData(
    firestore.doc(`/settings/free_deposit`)
  );

  const handleSignOut = async () => {
    await auth.signOut();
  };

  const openPaymentDetail = async () => {
    if (profil?.midtrans_registrasi?.transaction_status === "settlement") {
      history.push("/");
    }

    if (
      profil?.midtrans_registrasi?.transaction_id &&
      profil?.midtrans_registrasi?.transaction_status === "pending"
    ) {
      history.push(`/payment/${profil?.midtrans_registrasi?.token}`, {
        goBack: "/register/pembayaran",
      });
    } else {
      try {
        setLoading(true);
        const generateRegisterTransactionToken = firefunctions.httpsCallable(
          "generateRegisterTransactionToken"
        );
        const midtrans_registrasi = await generateRegisterTransactionToken({
          type: profil.tipe_akun,
        });

        // console.log(midtrans_registrasi?.data?.token)
        // add location to differend among reseller app or tukuyok
        let midtrans_registrasi_location = {
          location: "web",
        };

        await profilRef.set(
          {
            midtrans_registrasi: Object.assign(
              midtrans_registrasi_location,
              midtrans_registrasi.data
            ),
          },
          { merge: true }
        );

        history.push(`/payment/${midtrans_registrasi?.data?.token}`, {
          goBack: "/register/pembayaran",
        });
        setLoading(false);
      } catch (err) {
        console.log("Error Payment Details : ", err);
        if (err?.message?.includes("sudah digunakan")) {
          enqueueSnackbar(
            "Maaf, ID Anda sudah digunakan. Silahkan daftar ulang.",
            {
              variant: "warning",
            }
          );
          handleSignOut();
        } else {
          enqueueSnackbar(`${err.message}`, {
            variant: "error",
          });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const freeActivation = async (uplineId) => {
    try {
      setLoading(true);
      const activateFree = firefunctions.httpsCallable("activateFree");
      const data = { uid: profil.id, tipe_akun: profil.tipe_akun };

      if (uplineId) {
        data.upline_id = uplineId;
      }

      await activateFree(data);
      history.push("/register/info");
      setLoading(false);
    } catch (err) {
      console.log("error Free Activation : ", err);
      setLoading(false);
    }
  };

  const handleRegisBuy = async (e) => {
    try {
      setLoading(true);
      const data = { user_id: profil.id };
      const userInit = firefunctions.httpsCallable("userInit");
      await userInit(data);
      setLoading(false);
      history.push("/");
    } catch (e) {
      console.log(e.message);
      setLoading(false);
    }
  };

  const handleAktivasiAkun = () => {
    if (global_settings?.aktivasi_gratis_pendaftaran) {
      freeActivation();
    } else if (free_deposit_mentorbisnis?.active) {
      freeActivation(profil?.ref_mentorbisnis?.user_id);
    } else if (free_deposit_distributor?.active) {
      freeActivation(profil?.ref_distributor?.user_id);
    } else if (free_deposit_agen?.active) {
      freeActivation(profil?.ref_agen?.user_id);
    } else if (free_deposit_all?.[profil?.tipe_akun]) {
      freeActivation();
    } else if (global_settings?.aktivasi_register_by_order) {
      handleRegisBuy();
    } else {
      openPaymentDetail();
    }
  };

  const statusRegis =
    global_settings?.aktivasi_gratis_pendaftaran ||
    free_deposit_mentorbisnis?.active ||
    free_deposit_distributor?.active ||
    free_deposit_agen?.active ||
    free_deposit_all?.[profil?.tipe_akun];

  return (
    <div>
      <div className={classes.header}>
        <Navbar />
        <div>
          <div>
            <img
              src={ImageGelombang}
              alt="icon"
              className={classes.gelombang}
            />
          </div>
          {matches ? (
            <div
              style={{
                margin: "5%",
                marginLeft: "10%",
              }}
            >
              <img
                src={ImageFamily}
                alt="icon"
                style={{ width: "30%", position: "absolute" }}
              />
            </div>
          ) : null}
          <div>
            <div className={classes.content}>
              <div className={classes.boxContent}>
                <div className={classes.textContent3}>
                  <h4 className={classes.textContent3H4}>Tokorame.co.id</h4>
                </div>
                <div className={classes.garisContent} />
                <img
                  src={
                    statusRegis 
                      ? ImageKonfirmasi
                      : global_settings?.aktivasi_register_by_order
                      ? ImageOrderBuy
                      : ImageKonfirmasi
                  }
                  alt="icon"
                  style={{ marginTop: "5%", width: "50%" }}
                />
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 30,
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      fontFamily: "sans-serif",
                      fontWeight: "500%",
                    }}
                  >
                    {global_settings?.aktivasi_gratis_pendaftaran ||
                    free_deposit_mentorbisnis?.active ||
                    free_deposit_distributor?.active ||
                    free_deposit_agen?.active ||
                    free_deposit_all?.[profil?.tipe_akun]
                      ? "Akun Belum Aktif"
                      : global_settings?.aktivasi_register_by_order
                      ? `Saat Ini Kamu Terdaftar Sebagai ${profil?.tipe_akun} Tokorame.`
                      : "Akun Belum Aktif"}
                  </p>
                  <p
                    style={{
                      marginTop: "-4%",
                      color: "grey",
                    }}
                  >
                    {global_settings?.aktivasi_gratis_pendaftaran ||
                    free_deposit_mentorbisnis?.active ||
                    free_deposit_distributor?.active ||
                    free_deposit_agen?.active ||
                    free_deposit_all?.[profil?.tipe_akun]
                      ? "(Pendaftaran Gratis Sedang Berlaku)"
                      : global_settings?.aktivasi_register_by_order
                      ? ""
                      : "(Sedang Menunggu Pembayaran)"}
                  </p>
                </div>
                {global_settings?.aktivasi_register_by_order && !statusRegis && (
                  <div
                    style={{
                      borderRadius: 8,
                      border: "1px solid #FFE3AB",
                      backgroundColor: "#FFFCF5",
                      padding: 5,
                      margin: "0px 10px 10px 10px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "13px",
                      }}
                    >
                      Untuk mengaktifkan akun, kamu harus melakukan pembelian
                      senilai{" "}
                      {arrayToCurrencyString(
                        configuration?.registration_fee?.[profil?.tipe_akun]
                      )}
                    </Typography>
                  </div>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.formBottom}
                  onClick={handleAktivasiAkun}
                  loading={
                    loading ||
                    loadingDepositMentorbisnis ||
                    loadingDepositDistributor ||
                    loadingDepositAgen ||
                    loadingDepositAll
                  }
                  disabled={
                    loading ||
                    loadingDepositMentorbisnis ||
                    loadingDepositDistributor ||
                    loadingDepositAgen ||
                    loadingDepositAll ||
                    !profil
                  }
                >
                  {loading ||
                  loadingDepositMentorbisnis ||
                  loadingDepositDistributor ||
                  loadingDepositAgen ? (
                    <CircularProgress size={24} style={{ color: "#5675D3" }} />
                  ) : global_settings?.aktivasi_gratis_pendaftaran ||
                    free_deposit_mentorbisnis?.active ||
                    free_deposit_distributor?.active ||
                    free_deposit_agen?.active ||
                    free_deposit_all?.[profil?.tipe_akun] ? (
                    "Pendaftaran Gratis Sedang Berlaku"
                  ) : global_settings?.aktivasi_register_by_order ? (
                    "Mulai Pembelian"
                  ) : (
                    "Lihat Detail Metode Pembayaran"
                  )}
                </Button>
                <Button
                  color="primary"
                  className={classes.formBottom}
                  style={{ marginTop: "2%" }}
                  onClick={handleSignOut}
                >
                  Sign Out
                </Button>
              </div>
            </div>
            <div className={classes.textCopyright}>
              {matches1 ? (
                <h5 className={classes.textCopyrightH5}>
                  Copyright © TokoRame {year}
                </h5>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
